import { VariantProps, cva } from "cva";
import {
  statDescriptionStyles,
  statValueStyles,
} from "~/landing-pages/components/Stats/shared-stat-styles";
import { LandingPageStat } from "~/landing-pages/landing-page-types";
import { Body, Headline } from "~/ui-library";

const containerStyles = cva("py-12 sm:py-16 lg:py-24", {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      light: "bg-white",
      dark: "bg-gray-900",
      brand: "bg-brand-indigo",
    },
  },
});

type Props = {
  stats: LandingPageStat[];
} & VariantProps<typeof containerStyles> &
  VariantProps<typeof statDescriptionStyles> &
  VariantProps<typeof statValueStyles>;

export const StatsSimple: React.FC<Props> = ({ appearance, stats }) => (
  <div className={containerStyles({ appearance })}>
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
        {stats.map((stat) => (
          <div
            key={`${stat.name}-${stat.value}`}
            className="mx-auto flex max-w-xs flex-col gap-y-4"
          >
            <Body className={statDescriptionStyles({ appearance })}>
              {stat.name}
            </Body>
            <Headline
              as="h3"
              level={1}
              mdLevel={0}
              className={statValueStyles({ appearance })}
            >
              {stat.value}
            </Headline>
          </div>
        ))}
      </div>
    </div>
  </div>
);
